class DistrictModel {
    districtId?: number;
    name?: string;
    code?:string;
    capital?:string;
    stateName?:string;
    stateId?:number;
    sno?: number;
    count?: number;
}
 export default DistrictModel;       